var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 230",
    style: {
      enableBackground: "new 0 0 300 230"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.5,7H58.5c-8.8,0-15.9,6.9-15.9,15.5v185.1c0,8.5,7.1,15.5,15.9,15.5h182.9c8.8,0,15.9-6.9,15.9-15.5V22.5 C257.3,13.9,250.2,7,241.5,7z M75.3,187.8V90.3h32.4v97.5H75.3z M91.5,77L91.5,77h-0.2c-10.9,0-17.9-7.5-17.9-16.8 c0-9.6,7.2-16.9,18.3-16.9c11.1,0,17.9,7.3,18.1,16.9C109.9,69.5,102.8,77,91.5,77z M224.6,187.8h-32.4v-52.2 c0-13.1-4.7-22.1-16.4-22.1c-9,0-14.3,6-16.6,11.9c-0.9,2.1-1.1,5-1.1,7.9v54.5h-32.4v0v0l0,0c0-0.1,0.4-88.4,0-97.5h32.4v13.8 c4.3-6.6,12-16.1,29.2-16.1c21.3,0,37.3,13.9,37.3,43.9V187.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6367b65ebb7a26e562e2ea9503d4812b.svg";
export { ForwardRef as ReactComponent };